<template>
    <div class="rbr-page">
        <!-- Gold rays behind the hero -->
        <svg class="rbr-rays" viewBox="0 0 390 300" fill="none" preserveAspectRatio="none" aria-hidden="true">
            <path d="M195 -40L318 300H72L195 -40z" fill="url(#rbrRayA)" />
            <path d="M195 -40L392 250H-2L195 -40z" fill="url(#rbrRayB)" />
            <defs>
                <linearGradient id="rbrRayA" x1="195" y1="-40" x2="195" y2="300" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#F5C74E" stop-opacity="0.30" />
                    <stop offset="1" stop-color="#F5C74E" stop-opacity="0" />
                </linearGradient>
                <linearGradient id="rbrRayB" x1="195" y1="-40" x2="195" y2="250" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#F5C74E" stop-opacity="0.16" />
                    <stop offset="1" stop-color="#F5C74E" stop-opacity="0" />
                </linearGradient>
            </defs>
        </svg>

        <div class="rbr-inner">

            <!-- Hero -->
            <div class="rbr-hero">
                <svg class="rbr-hero-badge" width="76" height="84" viewBox="0 0 76 84" fill="none" aria-hidden="true">
                    <path d="M38 3L70 14v29c0 18-13.5 30.5-32 38C19.5 73.5 6 61 6 43V14L38 3z" fill="#141013"
                        stroke="#E9B93A" stroke-width="2.4" stroke-linejoin="round" />
                    <path d="M38 9.5L64 18.5v24c0 14.7-11 25.2-26 31.6C23 67.7 12 57.2 12 42.5v-24L38 9.5z" fill="none"
                        stroke="rgba(245,199,78,0.34)" stroke-width="1.3" />
                    <path d="M22 33l6.6 6L38 24.5 47.4 39l6.6-6v15.6a2 2 0 0 1-2 2H24a2 2 0 0 1-2-2V33z"
                        fill="url(#rbrCrown)" stroke="#C9920C" stroke-width="1.5" stroke-linejoin="round" />
                    <circle cx="22" cy="31" r="2.6" fill="#FFEFB8" stroke="#C9920C" stroke-width="1.1" />
                    <circle cx="54" cy="31" r="2.6" fill="#FFEFB8" stroke="#C9920C" stroke-width="1.1" />
                    <circle cx="38" cy="21.5" r="2.9" fill="#FFF7DA" stroke="#C9920C" stroke-width="1.1" />
                    <rect x="19" y="55" width="38" height="13" rx="3" fill="url(#rbrRibbon)" stroke="#C9920C"
                        stroke-width="1.4" />
                    <defs>
                        <linearGradient id="rbrCrown" x1="38" y1="24" x2="38" y2="51" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#FFE9A8" />
                            <stop offset="1" stop-color="#E1A519" />
                        </linearGradient>
                        <linearGradient id="rbrRibbon" x1="38" y1="55" x2="38" y2="68" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#F5C74E" />
                            <stop offset="1" stop-color="#D19B14" />
                        </linearGradient>
                    </defs>
                </svg>

                <h1 class="rbr-hero-title">REWARD<br>BLAST</h1>
                <div class="rbr-hero-tag">100% RETURN FOR ALL</div>
            </div>

            <!-- The whole mechanic in one card -->
            <div class="rbr-stat">
                <div class="rbr-stat-cap">1 ghante me</div>

                <div class="rbr-stat-row">
                    <div class="rbr-stat-col">
                        <span class="rbr-stat-label">Earning</span>
                        <span class="rbr-stat-from">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <circle cx="12" cy="12" r="9.6" fill="#F7C948" />
                                <circle cx="12" cy="12" r="6.3" fill="none" stroke="#B8830A" stroke-width="1.6" />
                            </svg>
                            <span class="rbr-num">25,000</span>
                        </span>
                    </div>

                    <svg class="rbr-stat-arrow" width="26" height="16" viewBox="0 0 26 16" fill="none"
                        stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M2 8h19" />
                        <path d="M16 3l5 5-5 5" />
                    </svg>

                    <div class="rbr-stat-col">
                        <span class="rbr-stat-label rbr-stat-label--gold">Extra bonus</span>
                        <span class="rbr-stat-to rbr-num">+25,000</span>
                    </div>
                </div>

                <p class="rbr-stat-line">Host ko 25,000 gifting per 50,000 ki earning</p>
            </div>

            <!-- How to qualify -->
            <div class="rbr-head">Kaise milega</div>
            <div class="rbr-list">
                <div v-for="(way, i) in ways" :key="way.title" class="rbr-way">
                    <span class="rbr-way-step">{{ i + 1 }}</span>
                    <div class="rbr-way-body">
                        <p class="rbr-way-title">{{ way.title }}</p>
                        <p class="rbr-way-text">{{ way.body }}</p>
                    </div>
                </div>
            </div>

            <!-- Timer rules -->
            <div class="rbr-head">Timer ke rules</div>
            <div class="rbr-list">
                <div v-for="rule in timerRules" :key="rule.tag" class="rbr-rule" :class="rule.variant">
                    <span class="rbr-rule-tag">{{ rule.tag }}</span>
                    <p class="rbr-rule-text">{{ rule.body }}</p>

                    <div v-if="rule.example" class="rbr-example">
                        <div class="rbr-example-cap">Example</div>
                        <p>{{ rule.example }}</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import './RewardBlastRuleStyle.css'

export default {
    name: 'RewardBlastRule',

    data() {
        return {
            ways: [
                {
                    title: 'Live Broadcast',
                    body: 'Host ko 1 ghante me 25,000 beans ki earning gift ya gold coin se ho jaye, to Reward Blast lagega aur extra 25,000 beans milenge.',
                },
                {
                    title: 'Party Room',
                    body: 'Party room me seat per baithe user ki 1 ghante me 25,000 beans ki earning ho jaye, to uska bhi Reward Blast hoga aur extra 25,000 beans milenge.',
                },
            ],

            timerRules: [
                {
                    tag: 'Call aane par',
                    variant: '',
                    body: 'Host call uthaye to countdown timer pause ho jayega, aur call se wapas aane par resume ho jayega.',
                    example: 'Timer 30 min bacha hai aur 20,000 ki gifting hui hai. Host 10 min call per jati hai — wapas aane par timer 30 min se hi shuru hoga aur 20,000 hi gift show honge. Call ki earning add nahi hogi.',
                },
                {
                    tag: 'App band karne par',
                    variant: 'rbr-rule--app',
                    body: 'Countdown ke beech app band kar di, to jitni der app band rahi utna time ghata diya jayega.',
                    example: 'Timer 30 min bacha tha, 20 min baad wapas app khol kar live aayi — ab timer me 10 min bachenge.',
                },
                {
                    tag: 'User ka countdown',
                    variant: 'rbr-rule--user',
                    body: 'User ka countdown party start karne per first time seat par baithne se shuru hoga. Party me call kar de to time pause ho jayega. Seat chhod de ya party band kar de, to timer chalta rahega.',
                    example: '',
                },
            ],
        }
    },
}
</script>
